import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
var _jsxFileName = "/Users/satya/Workspace/Callstack/react-navigation-core/src/views/SwitchView/SwitchView.js";
import React from 'react';
import SceneView from '../SceneView';

var SwitchView = function (_React$Component) {
  _inherits(SwitchView, _React$Component);

  function SwitchView() {
    _classCallCheck(this, SwitchView);

    return _possibleConstructorReturn(this, _getPrototypeOf(SwitchView).apply(this, arguments));
  }

  _createClass(SwitchView, [{
    key: "render",
    value: function render() {
      var state = this.props.navigation.state;
      var activeKey = state.routes[state.index].key;
      var descriptor = this.props.descriptors[activeKey];
      var ChildComponent = descriptor.getComponent();
      return React.createElement(SceneView, {
        component: ChildComponent,
        navigation: descriptor.navigation,
        screenProps: this.props.screenProps,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 12
        }
      });
    }
  }]);

  return SwitchView;
}(React.Component);

export { SwitchView as default };